// src/api/apiClient.js v15 from v14
/*
 ====== Changes from 14 - Jan 17 2026 1:42 am =======
 SB120 - Create CRUD for Supplier Item Variant Prices
 ====== Changes from 13 - Jan 12 2026 3:47 pm =======
 SB119 - Create "simple" CRUD for RawItemVariantPAckage (or resource)
 ====== Changes from 12 - Dec 16 2025 10:48 pm =======
 SB118a - add the 'listActvEmpNmIds' operation for employeeCrud
 ====== Changes from 11 - Oct 18 2025 4:16 am =======
 Pagination for Inventory list, supplier list - re-add query parameters
 ====== Changes from 10 =======
 To Do Priority 1a : Move Supplier DB into Tenants and Crud & Cleanup old coments
 ====== Changes from 09 =======
 To Do Priority 1 : Compress list, getById, add & update into function inventoryCrud
 cleanup old comments from ver 09
 ====== Changes from 08 =======
 Have 404 error be thrown as status into userProfile and tenantProfileForms. 
 ====== Changes from 07 =======
 re-organize base URL path buildup based on endpoint and pathParams
 cleanup old comments from ver 07
 ====== Changes from 06 =======
 cleanup old comments
 add entries for user profile
 add partial entries for tenant profile
 ==============================
*/
// IMPORTANT: Replace with your actual Cloud Function URLs after deployment.
// For local testing with Firebase Emulators (run `firebase emulators:start`):
// export const FUNCTIONS_BASE_URL = "http://127.0.0.1:5001/alpine-keep-448213-t6/us-central1";
// For deployed functions (replace YOUR_PROJECT_ID and YOUR_REGION):
export const FUNCTIONS_BASE_URL = "https://us-central1-alpine-keep-448213-t6.cloudfunctions.net";

// NEW ver 09: Custom Error class to include HTTP status
export class ApiError extends Error {
  constructor(message, status) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
  }
}

/**
 * Helper function to call Cloud Functions with authentication.
 * @param {string} endpoint The name of the Cloud Function (e.g., 'getInventoryItems').
 * @param {string} method HTTP method (GET, POST, PUT, DELETE).
 * @param {object} data Request body data for POST/PUT.
 * @param {string} id ID for operations like getById or update.
 * @param {string} token Firebase ID token for authorization.
 * @param {string} tenantid Tenant ID
 * @param {object} options Optional: Object containing various parameters.
 *                         - pathParams: { tenantId: 'abc', itemId: '123' }
 *                         - queryParams: { email: 'user@example.com', id: 'profile123' }
 * @returns {Promise<any>} Response data from the Cloud Function.
 */

// pathParams = {}) {
export async function callCloudFunction(endpoint, method = 'GET', data = null, id = null, token, tenantid, options = {}) {
  const {pathParams = {}, queryParams = {} } = options;


  let url = `${FUNCTIONS_BASE_URL}`;
  const queryString = new URLSearchParams(queryParams).toString();

    console.log(`1.endpoint = ${endpoint}, operation = ${pathParams.operation}, tenantid = ${pathParams.tenantid}, id = ${pathParams.id}`); // , token = ${token}

  if (endpoint === 'addUserProfile' || endpoint === 'addTenantProfile') {
    url += `/${endpoint}`;

  } else if (endpoint === 'getTenantProfile' || endpoint === 'updateTenantProfile') {
    url += `/${endpoint}/${pathParams.tenantDocId}`

  // } else if ((endpoint === 'getUserProfile' || endpoint === 'updateUserProfile') && queryString) {
  //   url += `/${endpoint}/?${queryString}`; // modified V12

  } else if (endpoint === 'getUserProfile' || endpoint === 'updateUserProfile') {
    url += `/${endpoint}`;

  // } else if (endpoint.includes('Crud') && (pathParams.operation === 'list' || pathParams.operation === 'add' || pathParams.operation === 'listActvEmpNmIds' || pathParams.operation === 'listActvItemVrtNmIds' || pathParams.operation === 'listActvItmVrntPkgNm' || pathParams.operation === 'listActvSuplrCds')) { // V34
  //   url += `/${endpoint}/${pathParams.operation}/${pathParams.tenantid}`;

  } else if (endpoint.includes('Crud') && (pathParams.operation === 'getById' || pathParams.operation === 'update')) { // V11
    url += `/${endpoint}/${pathParams.operation}/${pathParams.tenantid}/${pathParams.id}`;

  } else if (endpoint.includes('Crud') && (pathParams.operation !== 'getById' && pathParams.operation !== 'update')) { // V34 shortcut to long Crud entries above
    url += `/${endpoint}/${pathParams.operation}/${pathParams.tenantid}`;

  } else if ((endpoint.includes('get') && endpoint.includes('ById'))  || (endpoint.includes('update'))) {
    url += `/${endpoint}/${pathParams.tenantid}/${pathParams.id}`;
  
  } else {
    url += `/${endpoint}/${pathParams.tenantid}`;
  }

  // Append query parameters added V12
  if (queryString) {
    url += `/?${queryString}`;
  }

  // *********** =====================================  **************

  const headers = {
    'Content-Type': 'application/json',
  };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const config = {
    method: method,
    headers: headers,
  };

  if (data && (method === 'POST' || method === 'PUT' || method === 'PATCH')) {
    config.body = JSON.stringify(data);
  }

  console.log('url: ', url);
  console.log('config: ', config)
  console.log('TenantId:', tenantid)
  console.log(`paramTenantId: ${pathParams.tenantid}`)
  console.log(`paramTenantDocId: ${pathParams.tenantDocId}`)
  console.log('paramid:', pathParams.id)

  const response = await fetch(url, config);

  if (!response.ok) {
    const errorBody = await response.text();
    let errorMessage = `HTTP error! Status: ${response.status}`;
    try {
        const errorJson = JSON.parse(errorBody);
        errorMessage = errorJson.message || errorJson.error || errorBody;
    } catch (e) {
        errorMessage = errorBody;
    }
    throw new ApiError(errorMessage, response.status); // Ver 09: Replaces above
  }
  
  const contentType = response.headers.get("content-type");
  if (response.status === 204 || (contentType && !contentType.includes("application/json"))) {
      return null;
  }
  return response.json();
}